import React, {useEffect} from 'react';
import Header from '../../Units/Header';
import GrandCredit from './components/GrantCredit';

const GrandCreditHistory = () => {
    return (
        <div className={`agentMenu`}>
            <Header title={'grandCreditHistoryTitle'} className="dialogHeader--gray"/>
            <GrandCredit isHistory={true} />
        </div>
    );
};

export default GrandCreditHistory ;
